import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Icon, Text } from '../../../components/BaseComponents'
import { useReselector } from '../../../utils/sharedHooks'
import { selectPracticeOverviewAlertType } from './practiceOverviewAlerts.selectors'
import { useAnalyticsTrack } from '@/featuresV1/Amplitude'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

const PracticeOverviewAlert: FC = () => {
  const navigate = useNavigate()
  const track = useAnalyticsTrack()
  const alertType = useReselector(selectPracticeOverviewAlertType)

  if (!alertType) {
    return null
  }

  const alertStyleProps = {
    type: 'warn' as const,
    fullWidth: true,
    style: {
      marginBottom: 24,
      marginTop: 24,
      marginLeft: 16,
      marginRight: 16,
    },
    innerTextStyle: {
      fontSize: 14,
    },
  }

  switch (alertType) {
    case 'BANK_STATEMENTS':
      return (
        <Alert {...alertStyleProps} title="Data pending">
          <div style={{ display: 'flex', gap: 16 }}>
            <Text as="bodySm" color="charcoal">
              We need your <strong>bank statements</strong> to provide an
              accurate view of your Practice Overview insights. Upload your
              statements so we can complete your catch-up bookkeeping.
            </Text>
            <Button
              onClick={() => {
                track(
                  'Clicked Upload Statements Button in Practice Overview Alert'
                )
                navigate('/practice/documents?tab=bank')
              }}
              variant="primary"
              size="small"
              style={{ whiteSpace: 'nowrap' }}
            >
              Upload Statements{' '}
              <Icon
                icon={regular('arrow-right')}
                style={{
                  fontSize: 12,
                  marginLeft: 6,
                }}
              />
            </Button>
          </div>
        </Alert>
      )

    case 'CLARIFY_TRANSACTIONS':
      return (
        <Alert {...alertStyleProps} title="Data pending">
          <div style={{ display: 'flex', gap: 16 }}>
            <Text as="bodySm" color="charcoal">
              Please clarify <strong>outstanding transactions</strong> so we can
              complete your catch-up bookkeeping. This is needed to provide an
              accurate view of your Practice Overview insights.
            </Text>
            <div style={{ marginTop: 16 }}>
              <Button
                onClick={() => {
                  track(
                    'Clicked Clarify Transactions Button in Practice Overview Alert'
                  )
                  navigate('/transactions/review')
                }}
                variant="primary"
                size="small"
                style={{ whiteSpace: 'nowrap' }}
              >
                Clarify Transactions{' '}
                <Icon
                  icon={regular('arrow-right')}
                  style={{
                    fontSize: 12,
                    marginLeft: 6,
                  }}
                />
              </Button>
            </div>
          </div>
        </Alert>
      )

    case 'CUBK_IN_PROGRESS':
      return (
        <Alert {...alertStyleProps} title="Catch-up bookkeeping in progress">
          <Text as="bodySm" color="charcoal">
            This is a <strong>preview</strong> of your Practice Overview
            insights. Your data will be finalized after we complete your
            catch-up bookkeeping.
          </Text>
        </Alert>
      )

    default:
      return null
  }
}

export default PracticeOverviewAlert
